export default __webpack_public_path__ + "static/media/nhl-player-mobile.e680aa44.png";